import FallbackUtil from 'src/components/Video/FallbackUtil';
import Utils from 'src/utils/Utils';

import { utilsPlayersControls } from 'src/playerDomain/components/utils/index'
import { utilsSeeks } from 'src/playerDomain/components/seeks/index'

const calculateFinalSeekTime = (isBackward, seekTime, _this) => {
    FallbackUtil.clearFallback();
    if (_this.state.timeshiftEventInfo && _this.state.timeshiftEventInfo.event) {
        // TODO revisar si esta bandera realmente se usa ¿?
        if (_this.switchingBetweenEventTimeshift) {
            console.log('PAU> function handleTimeshiftSeekByEvent rejected*****> ');
            return;
        }

        if (_this.hasTimeshift()) {
            if (_this.timerTimeshitDelayId) clearTimeout(_this.timerTimeshitDelayId);
            const currTime = _this.getCurrentTime();
            if (isBackward) {
                // ONLY BACKWARD - LIVE TV
                if (!_this.waitForSeconds) _this.waitForSeconds = true;
                const threshold_seconds = 0.25 * 60;
                if (
                    Utils.nowAsTimestampSeconds() -
                        _this.state.timeshiftEventInfo.event.date_begin >
                    threshold_seconds
                ) {
                    const newCurrentTime = currTime - seekTime < 0 ? 0 : currTime - seekTime;
                    _this.setCurrentTime(newCurrentTime);
                    if (newCurrentTime < currTime) {
                        _this.timeshiftTime = newCurrentTime;
                    }
                    _this.backwardIsMoving = true;
                }
            }
            // Si es forward, sólo si esta en pausa el live se permite mover el punto
            // en que puso la pausa
            else {
                // Doble check ¿?, si no esta en pausa, forward no hace nada
                if (_this.pendingLiveOnPause === null) return;

                const newCurrentTime =
                    currTime + seekTime > _this.pendingLiveOnPause
                        ? _this.pendingLiveOnPause
                        : currTime + seekTime;
                _this.setCurrentTime(newCurrentTime);
                _this.timeshiftTime = newCurrentTime;
                _this.backwardIsMoving = true;
            }

            const timeshiftDelay = _this.getDuration() - _this.getCurrentTime();
            const timeshiftData = {
                timeshiftEvent: Object.assign({}, _this.state.timeshiftEventInfo.event),
                backward: isBackward,
                // Si es negativo o no, se verifica en video/component, quien es quien decide
                // si se va o no a pgm o solo hace seek sobre el actual playing
                seektime: _this.timeshiftTime,
                maxtimeshiftallowed: _this.state.timeshiftEventInfo.channelTimeshiftAllowed,
                timeshiftDelay,
            };

            console.log(
                '[NPC] PlayerControls > handleTimeshiftSeekByEvent > _this.getCurrentTime() : ',
                _this.getCurrentTime()
            );

            //                _this.backwardIsMoving = true;
            _this.updateCurrentTimeUI();
            // El user pausó live y entonces está pendiente que
            // un siguiente posible clic en play para entrar
            // en startover
            if (_this.pendingLiveOnPause !== null) {
                return;
            }

            utilsSeeks.sendForwardRewindSeek(timeshiftData, _this);

            _this.timerTimeshitDelayId = setTimeout(() => {
                _this.props.hide();
                _this.timerTimeshitDelayId = null;
                utilsPlayersControls.performTimeshift(timeshiftData, _this);
                _this.resetLiveTimeshift();
            }, _this.delayTimeshiftSeek);
        }
    }
};

export const seekLiveTS = {
    calculateFinalSeekTime,
};



// WEBPACK FOOTER //
// ./src/playerDomain/components/seeks/seekLiveTS.js